import { Paper } from '@mui/material';
import { DashboardPageContainer, UserInput } from '@carcareers/components';
import { FormProvider } from '@carcareers/contexts';
import { useAuth } from '@carcareers/hooks';

export const SettingsIndex = () => {
  const { session } = useAuth();

  return (
    <DashboardPageContainer>
      <Paper elevation={0} sx={{ borderRadius: 3, p: 4 }}>
        <FormProvider initialData={session}>
          <UserInput disabled />
        </FormProvider>
      </Paper>
    </DashboardPageContainer>
  );
};

export default SettingsIndex;
